import React from 'react'

const IconHome = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <path d='M4 11l8-7 8 7' />
         <path d='M6 10v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9' />
      </svg>
   )
}
export default IconHome
